/* Florage Lead-Widget v3, Stand 07.10.2026
 *
 * Ersetzt das Inline-Skript aus article-ebook-widget.liquid.
 *
 * Unterschiede zum heutigen Stand, alle aus der Messung begruendet:
 *  1. Quelle je Artikel  (heute traegt jeder Kontakt dieselbe Quelle, damit ist kein Artikel auswertbar)
 *  2. Vorname            (die Mai-Kontakte hatten einen, die Quote lag damals bei 0,227 statt 0,116 Prozent)
 *  3. mehrere Positionen (im Mai verteilt, seit Juli nur eine Stelle nach zwei Dritteln)
 *  4. Formular sichtbar   (Mai-Fassung mit sichtbarem Formular lag bei 0,227 Prozent)
 *  5. Erfolgsbild fuehrt zur Bestaetigung, kein Downloadlink vor dem Double-Opt-in
 *  6. Profil-Eigenschaften fuer die Themen-Weiche in der Willkommensstrecke
 *
 * Kein Framework, keine Abhaengigkeit, laeuft mit defer.
 */
(function () {
  'use strict';

  var RE_MAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var REV = '2024-10-15';
  var STORE_KEY = 'fl-lw-state';

  /* ---------- kleine Helfer ---------- */

  function readState() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function writeState(patch) {
    try {
      var s = readState();
      for (var k in patch) { s[k] = patch[k]; }
      window.localStorage.setItem(STORE_KEY, JSON.stringify(s));
    } catch (e) { /* Privatmodus, ignorieren */ }
  }

  /* ---------- Einbau in den Artikeltext ---------- */

  function findProse() {
    var sel = ['.blg-prose', '.article__content', '.rte', '.article-content', 'article .rte'];
    for (var i = 0; i < sel.length; i++) {
      var el = document.querySelector(sel[i]);
      if (el && el.children.length > 4) { return el; }
    }
    return null;
  }

  /* Absatzpositionen, an denen eingefuegt werden darf: zwischen zwei Absaetzen,
     nie direkt vor einer Ueberschrift, nie in den ersten beiden Elementen. */
  function slots(prose) {
    var kids = Array.prototype.slice.call(prose.children);
    var out = [];
    for (var i = 2; i < kids.length; i++) {
      var prev = kids[i - 1].tagName.toLowerCase();
      var cur = kids[i].tagName.toLowerCase();
      if (prev === 'p' && (cur === 'p' || cur === 'h2' || cur === 'h3')) { out.push(i); }
    }
    return out;
  }

  function nearest(list, target, taken, minGap) {
    var best = null, bd = Infinity;
    for (var i = 0; i < list.length; i++) {
      var s = list[i], ok = true;
      for (var j = 0; j < taken.length; j++) {
        if (Math.abs(taken[j] - s) < minGap) { ok = false; break; }
      }
      if (!ok) { continue; }
      var d = Math.abs(s - target);
      if (d < bd) { bd = d; best = s; }
    }
    return best;
  }

  function inject(root) {
    var prose = findProse();
    var big = root.querySelector('[data-lw-tpl="big"]');
    var small = root.querySelector('[data-lw-tpl="small"]');
    if (!big || !small) { return []; }

    var placed = [];

    /* Immer: eine Kurzfassung am Ende des Artikels. Funktioniert auch ohne prose. */
    var tail = small.content.firstElementChild.cloneNode(true);
    tail.setAttribute('data-lw-pos', 'end');
    if (prose) { prose.appendChild(tail); } else { root.parentNode.insertBefore(tail, root); }
    placed.push(tail);

    if (!prose) { return placed; }

    var kids = Array.prototype.slice.call(prose.children);
    var n = kids.length;
    var list = slots(prose);
    if (!list.length) { return placed; }

    var taken = [];
    var minGap = 4;

    /* Grosse Fassung bei rund 35 Prozent, Kurzfassung bei rund 70 Prozent.
       Bei kurzen Artikeln bleibt es bei einer Einbindung im Text. */
    var plan = n >= 14
      ? [{ at: Math.round(n * 0.35), tpl: big, name: 'mid' }, { at: Math.round(n * 0.7), tpl: small, name: 'late' }]
      : [{ at: Math.round(n * 0.5), tpl: big, name: 'mid' }];

    plan.forEach(function (p) {
      var idx = nearest(list, p.at, taken, minGap);
      if (idx == null) { return; }
      taken.push(idx);
      var node = p.tpl.content.firstElementChild.cloneNode(true);
      node.setAttribute('data-lw-pos', p.name);
      prose.insertBefore(node, kids[idx]);
      placed.push(node);
    });

    return placed;
  }

  /* ---------- Anmeldung ---------- */

  function subscribe(cfg, data) {
    var qs = '?company_id=' + encodeURIComponent(cfg.key);

    var profile = {
      data: {
        type: 'profile',
        attributes: {
          email: data.email,
          properties: {
            capture_source: cfg.source,
            topic_interest: cfg.cluster,
            capture_position: data.position,
            capture_date: new Date().toISOString()
          }
        }
      }
    };
    if (data.firstName) { profile.data.attributes.first_name = data.firstName; }

    var sub = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source,
          profile: { data: { type: 'profile', attributes: { email: data.email } } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.list } } }
      }
    };

    var head = { 'Content-Type': 'application/json', revision: REV };

    /* Schritt 1 legt das Profil mit Eigenschaften an, Schritt 2 meldet zur Liste an.
       409 heisst, das Profil gibt es schon. Beides ist in Ordnung. */
    return fetch('https://a.klaviyo.com/client/profiles/' + qs, {
      method: 'POST', headers: head, body: JSON.stringify(profile)
    }).then(function (r) {
      if (!r.ok && r.status !== 409) {
        return r.json().then(function (d) { throw msgFrom(d); });
      }
      return fetch('https://a.klaviyo.com/client/subscriptions/' + qs, {
        method: 'POST', headers: head, body: JSON.stringify(sub)
      });
    }).then(function (r) {
      if (r.status === 202 || r.ok) { return true; }
      return r.json().then(function (d) { throw msgFrom(d); });
    });
  }

  function msgFrom(d) {
    try {
      if (d && d.errors && d.errors[0] && d.errors[0].detail) { return d.errors[0].detail; }
    } catch (e) { /* egal */ }
    return 'Das hat gerade nicht geklappt. Versuch es bitte noch einmal.';
  }

  /* Meldet den Abschluss an klaviyo.js, damit ein spaeteres Formular
     diese Person als bekannt erkennt und nicht noch einmal fragt. */
  function identify(email) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ email: email });
      }
    } catch (e) { /* egal */ }
  }

  /* ---------- Verhalten je eingebautem Block ---------- */

  function wire(node, cfg) {
    var openBtn = node.querySelector('[data-lw-open]');
    var form = node.querySelector('[data-lw-form]');
    var done = node.querySelector('[data-lw-done]');
    var err = node.querySelector('[data-lw-err]');
    var emailEl = node.querySelector('[data-lw-email]');
    var nameEl = node.querySelector('[data-lw-name]');
    var submit = node.querySelector('[data-lw-submit]');
    var btnText = node.querySelector('[data-lw-btn-text]');
    var btnLoad = node.querySelector('[data-lw-btn-load]');
    var position = node.getAttribute('data-lw-pos') || 'mid';

    var state = readState();

    /* Wer schon abgeschickt, aber noch nicht bestaetigt hat, bekommt keinen
       zweiten Anlauf angeboten, sondern den Hinweis auf die Bestaetigungsmail. */
    if (state.submitted) {
      if (openBtn) { openBtn.hidden = true; }
      if (form) { form.hidden = true; }
      if (done) { done.hidden = false; }
      return;
    }

    /* Einstieg einmal je Block zaehlen, beim ersten Fokus auf ein Feld. */
    if (form) {
      var started = false;
      form.addEventListener('focusin', function () {
        if (started) { return; }
        started = true;
        track('Started Signup', cfg, position);
      });
    }

    if (emailEl) {
      emailEl.addEventListener('input', function () {
        if (err) { err.hidden = true; }
        emailEl.classList.remove('is-invalid');
      });
    }

    if (!form) { return; }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = (emailEl && emailEl.value || '').trim();
      var firstName = (nameEl && nameEl.value || '').trim();

      if (!RE_MAIL.test(email)) {
        if (err) { err.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.'; err.hidden = false; }
        if (emailEl) { emailEl.classList.add('is-invalid'); }
        return;
      }

      loading(true);
      subscribe(cfg, { email: email, firstName: firstName, position: position })
        .then(function () {
          writeState({ submitted: true, email: email, at: Date.now() });
          identify(email);
          loading(false);
          form.hidden = true;
          if (openBtn) { openBtn.hidden = true; }
          if (done) { done.hidden = false; }
          hideOthers(node);
        })
        .catch(function (m) {
          loading(false);
          if (err) { err.textContent = (typeof m === 'string' ? m : 'Verbindungsfehler. Bitte versuch es noch einmal.'); err.hidden = false; }
        });
    });

    function loading(on) {
      if (submit) { submit.disabled = on; }
      if (btnText) { btnText.hidden = on; }
      if (btnLoad) { btnLoad.hidden = !on; }
    }
  }

  /* Nach erfolgreicher Anmeldung alle anderen Blocks im Artikel zuklappen. */
  function hideOthers(current) {
    document.querySelectorAll('.lw').forEach(function (el) {
      if (el === current) { return; }
      var d = el.querySelector('[data-lw-done]');
      var f = el.querySelector('[data-lw-form]');
      var o = el.querySelector('[data-lw-open]');
      if (o) { o.hidden = true; }
      if (f) { f.hidden = true; }
      if (d) { d.hidden = false; }
    });
  }

  /* Zaehlt den Einstieg. Nur bei geladenem klaviyo.js, sonst still. */
  function track(name, cfg, position) {
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', name, {
          cluster: cfg.cluster,
          source: cfg.source,
          position: position
        }]);
      }
    } catch (e) { /* egal */ }
  }

  /* ---------- Start ---------- */

  function init() {
    var root = document.querySelector('[data-lw]');
    if (!root) { return; }

    var cfg = {
      key: root.getAttribute('data-lw-key'),
      list: root.getAttribute('data-lw-list'),
      cluster: root.getAttribute('data-lw-cluster'),
      source: root.getAttribute('data-lw-source')
    };
    if (!cfg.key || !cfg.list) { return; }

    var nodes = inject(root);
    nodes.forEach(function (n) { wire(n, cfg); });
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
